// components/MetaManager.js
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";

const MetaManager = ({ slug }) => {
  const [meta, setMeta] = useState({
    title: "",
    description: "",
    keywords: "",
    ogImage: "",
    ogUrl: window.location.href,
  });

  useEffect(() => {
    if (!slug) return;

    axios
      .get(`https://admin.socioloom.com/meta.php`, {
        params: { slug }, // ✅ Send as query param
      })
      .then((res) => {
        const data = res.data;
        console.log(data.title);
        if (data.title != "") {
          setMeta({
            title: data.title || "",
            description: data.description || "",
            keywords: data.keywords || "",
            ogImage: data.og_image || "",
            ogUrl: window.location.href,
          });
        } else {
          console.warn("Meta fetch failed:", data.message);
        }
      })
      .catch((err) => {
        console.error("Meta tag fetch error:", err);
      });
  }, [slug]);

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="keywords" content={meta.keywords} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:image" content={meta.ogImage} />
      <meta property="og:url" content={meta.ogUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      {/* ✅ Canonical URL */}
      <link rel="canonical" href={meta.ogUrl} />
      {/* ✅ Structured Data */}
      <script type="application/ld+json">
        {`
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Socioloom - Your Vision, Our Code",
      "url": "https://www.socioloom.com/",
      "logo": "https://socioloom.com/static/media/footerLogo.60fa5d8efa159b238f39.png",
      "description": "Boost your online presence with Sociolooms expert web development, digital marketing, and IT solutions tailored to grow and future-proof your business.
",
      "sameAs": [
        "https://www.facebook.com/people/Socioloom/61577859779021",
        "https://x.com/Socio_Loom",
        "https://www.instagram.com/socio_loom/",
        "https://www.linkedin.com/company/107837511/"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-7988066536",
        "contactType": "Customer Service",
        "areaServed": ["United States", "India", "United Kingdom", "United Arab Emirates"],
        "availableLanguage": ["English", "Hindi"]
      }
    }
  `}
      </script>
      <script type="application/ld+json">
{`{
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Socioloom - Your Vision, Our Code",
  "image": "https://socioloom.com/static/media/footerLogo.60fa5d8efa159b238f39.png",
  "@id": "",
  "url": "https://www.socioloom.com/",
  "telephone": "+91-7988066536",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pocket B-4 , Mayur vihar phase 3 ,Delhi ",
    "addressLocality": "New Delhi",
    "postalCode": "110096",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 28.60491291503361,
    "longitude": 77.33572852883572 
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "opens": "10:00",
    "closes": "18:00"
  },
  "sameAs": [
        "https://www.facebook.com/people/Socioloom/61577859779021",
        "https://x.com/Socio_Loom",
        "https://www.instagram.com/socio_loom/",
        "https://www.linkedin.com/company/107837511/"
      ]
}`}
</script>
<script async src="https://www.googletagmanager.com/gtag/js?id=G-KVK7PR5LRD"></script>
<script>
  {`
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'G-KVK7PR5LRD');
  `}
</script>


    </Helmet>
  );
};

export default MetaManager;
